<template>
  <div class="nx-bag-create-tag-button">
    <nx-bag-block-button :title="$t('message.bag.newSearch')"
                         :loading="dialogState.searcherModal.render"
                         @click="openDialog('searcherModal')" />

    <nx-bag-search-preview-dialog
      v-if="dialogState.searcherModal.render"
      :active="dialogState.searcherModal.active"
      entity="content"
      :title="$t('message.bag.newSearch')"
      @created="$emit('created', $event)"
      @dismiss="closeDialog('searcherModal')" />
  </div>
</template>

<script>
import NxBagBlockButton from '../common/BagBlockButton';
import NxBagSearchPreviewDialog from '@/modules/bag/components/search/BagSearchPreviewDialog';
import ManageDialogs, { initDialog } from '@/mixins/manage-dialogs';

export default {
  components: {
    NxBagBlockButton,
    NxBagSearchPreviewDialog,
  },
  mixins: [ManageDialogs],
  data() {
    return {
      dialogState: {
        searcherModal: initDialog(),
      },
    };
  },
};
</script>
